import { Spinner } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SSpinner = styled(Spinner)``;
